import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const InstructorDashboard: React.FC = () => {
  // Mock data for instructor
  const assignedStudents = [
    { id: 1, name: "Alice Johnson", course: "Basic Driving Course", progress: 30, nextSession: "Tomorrow, 2:00 PM" },
    { id: 2, name: "Bob Williams", course: "Highway Driving", progress: 50, nextSession: "Today, 4:00 PM" },
    { id: 3, name: "Charlie Brown", course: "Basic Driving Course", progress: 80, nextSession: "Friday, 10:00 AM" },
  ];
  const schedule = [
    { id: 1, date: "2023-05-25", time: "2:00 PM - 4:00 PM", student: "Alice Johnson", course: "Basic Driving Course" },
    { id: 2, date: "2023-05-25", time: "4:00 PM - 6:00 PM", student: "Bob Williams", course: "Highway Driving" },
    { id: 3, date: "2023-05-26", time: "10:00 AM - 12:00 PM", student: "Charlie Brown", course: "Basic Driving Course" },
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Instructor Dashboard</h1>
      <div className="mb-8">
        <Card>
          <CardHeader><CardTitle>Assigned Students</CardTitle></CardHeader>
          <CardContent>
            <ul>
              {assignedStudents.map((s) => (
                <li key={s.id} className="mb-2">{s.name} - {s.course} - Progress: {s.progress}% - Next: {s.nextSession}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
      <div>
        <Card>
          <CardHeader><CardTitle>Schedule</CardTitle></CardHeader>
          <CardContent>
            <ul>
              {schedule.map((s) => (
                <li key={s.id} className="mb-2">{s.course} with {s.student} - {s.date} {s.time}</li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
export default InstructorDashboard;
